export class UserVisibleError extends Error {
  showTpContactDetails: boolean

  constructor(
    message: string,
    showTpContactDetails = false
  ) {
    super(message)
    this.name = "User Visible Error"
    this.showTpContactDetails = showTpContactDetails
  }
}
